import z from 'zod';

export const CietyConnectReqBodySchema = z.object({
  projectId: z.string(),
  subdomain: z.string(),
});

export const CietyDisConnectReqBodySchema = z.object({
  projectId: z.string(),
  daoId: z.string(),
});
